import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-footer-page',
  templateUrl: './footer-page.component.html',
  styleUrls: ['./footer-page.component.sass']
})
export class FooterPageComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
